import styled from 'styled-components';

export const ElementSummaryWrapper = styled.div`
  padding: 6px 9px;
  width: 100%;
  border-top: 1px solid ${props => props.theme.colorSplit};
  transition: background-color 0.3s ease-in-out;
  &:last-child {
    border-bottom: 1px solid ${props => props.theme.colorSplit};
  }
  &:hover {
    background-color: ${props => props.theme.colorFillQuaternary};
  }
`;

export const ElementTitle = styled.div`
  margin-bottom: 0;
  font-size: 1.1rem;
  font-weight: 800;
  padding: 6px;
  & span[role='img'] {
    font-weight: 500;
  }
`;
